module.exports = __webpack_public_path__ + "img/down.e04e8b06.svg";